import React, { useState } from 'react';
import PropTypes from 'prop-types';

function withColumnSort(otherProps) {
  return (Component) => {
    function ComponentWithColumnSort(props) {
      const { tableName, defaultSort } = props;

      let defaultColumn;
      let defaultOrder;

      if (otherProps) {
        defaultColumn = otherProps.defaultColumn;
        defaultOrder = otherProps.defaultOrder;
      } else {
        defaultColumn = defaultSort.column;
        defaultOrder = defaultSort.order;
      }

      const storageKey = `${tableName}.search`;

      const searchParameters = JSON.parse(localStorage.getItem(storageKey) || '{}');
      const sortOrder = searchParameters.sortOrder || defaultOrder;
      const sortColumn = searchParameters.sort || defaultColumn;
      const [sorter, setSorter] = useState({ column: sortColumn, order: sortOrder });

      const handleChangeSort = (column, isAsc) => {
        const order = isAsc ? 'desc' : 'asc';
        localStorage.setItem(
          storageKey,
          JSON.stringify({
            ...JSON.parse(localStorage.getItem(storageKey) || '{}'),
            sort: column,
            sortOrder: order.toUpperCase()
          })
        );

        setSorter({ column, order });
      };

      const allProps = { ...props, sortOrder, sortColumn, sorter, handleChangeSort };

      return <Component {...allProps} />;
    }

    ComponentWithColumnSort.propTypes = {
      tableName: PropTypes.string,
      defaultSort: PropTypes.shape({
        order: PropTypes.oneOf(['asc', 'desc']),
        column: PropTypes.string
      })
    };
    ComponentWithColumnSort.defaultProps = {
      tableName: '',
      defaultSort: { order: 'asc', column: undefined }
    };

    return ComponentWithColumnSort;
  };
}

export const columnSortPropTypes = {
  sortOrder: PropTypes.string,
  sortColumn: PropTypes.string,
  sorter: PropTypes.shape({ column: PropTypes.string, order: PropTypes.string }),
  handleChangeSort: PropTypes.func
};
withColumnSort.propTypes = columnSortPropTypes;

export const columnSortDefaultProps = {
  sortOrder: '',
  sortColumn: '',
  sorter: PropTypes.shape({ column: '', order: 'asc' }),
  handleChangeSort: () => {}
};
withColumnSort.defaultProps = columnSortDefaultProps;

export default withColumnSort;
